import { render, staticRenderFns } from "./share-pop.vue?vue&type=template&id=7dc61edc&scoped=true&"
import script from "./share-pop.vue?vue&type=script&lang=js&"
export * from "./share-pop.vue?vue&type=script&lang=js&"
import style0 from "./share-pop.vue?vue&type=style&index=0&id=7dc61edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc61edc",
  null
  
)

export default component.exports